<template>
  <v-container
    id="ur-list"
  >
    <sala-municipio-header
      :payload="payload"
      v-if="isAuthenticated"
    >
    </sala-municipio-header>

    <v-row>
      <v-col><h3><b>5W2H</b></h3></v-col>
      <v-col
        class="text-right"
      >

        <app-modal-insert-ur
          v-if="isAdmin"
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadIndicadoresMunicipio"
        >
          <template v-slot:title
            :edit="false"
          >
            Cadastrar 5w2h
          </template>
        </app-modal-insert-ur>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >

        <template v-slot:item.nome="{ item }">
          <span>
            {{ item.nomeIndicador }}
          </span>
        </template>
        <template v-slot:item.nomeNivel="{ item }">
          <span v-html="item.nomeNivel">
          </span>
        </template>
        <template v-slot:item.Serie="{ item }">
          <span v-html="item.Serie">
          </span>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-insert-ur
                v-if="isAdmin"
                :object="item"
                :edit="true"
                :color="'warning'"
                :icon="'mdi-pencil'"
                @on-save="loadIndicadoresMunicipio"
              >
                <template v-slot:title>
                  Editar 5w2h
                </template>
              </app-modal-insert-ur>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.acoes_delete="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-delete
                    v-if="isAdmin"
                    :object="item"
                    @on-save="loadIndicadoresMunicipio"
                  >
                    <template v-slot:title>
                      Deletar
                    </template>
                  </app-modal-delete>
            </v-col>

            <v-col
              cols="1"
            >
            </v-col>
          </v-row>
        </template>

        <template slot="no-data">
          <span>
            Nenhum Indicador retornado
          </span>
        </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertUr from './ModalInsert'
import { Sala5w2hAPI } from '../API/Sala5w2h'
import { mapActions, mapGetters } from 'vuex'
import AppModalDelete from './../components/ModalDelete'
import SalaMunicipioHeader from '../../sala-principal/components/SalaMunicipioHeader'
import moment from 'moment'

export default {
  components: {
    AppModalInsertUr,
    AppModalDelete,
    SalaMunicipioHeader
  },
  data () {
    return {
      headers: [
        { text: 'Quem', value: 'quem', width: '150px' },
        { text: 'O que', value: 'oQue', width: '150px' },
        { text: 'Porque', value: 'porque', width: '150px' },
        { text: 'Como', value: 'como', width: '150px' },
        { text: 'Quanto Custa', value: 'quantoCusta', width: '150px' },
        { text: 'Editar', value: 'acoes', width: '150px', sortable: false },
        { text: 'Excluir', value: 'acoes_delete', width: '150px', sortable: false }
      ],
      payload: []
    }
  },
  methods: {
    ...mapActions([
      'setLoading',
      'setConsultorCondutorMunicipio',
      'setConsultorEspecialistaMunicipio',
      'setAnalistaMunicipio',
      'setADMunicipio'
    ]),
    loadIndicadores () {
      this.setLoading(true)
      Sala5w2hAPI.getbyMunicipio(this.$route.params.id)
        .then(resp => {
          this.payload = resp.data.map(item => {
            return ({
              sala5w2hid: item.sala5w2hid,
              quem: item.quem,
              oQue: item.oQue,
              porque: item.porque,
              como: item.porque,
              quantoCusta: item.quantoCusta,
              municipioId: item.municipioId,
              data: moment(item.data).format('DD/MM/YYYY hh:ss')
            })
          })

          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter os dados')
        })
    }
  },
  mounted () {
    this.loadIndicadores()
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isConsultorCondutorMunicipio',
      'isConsultorEspecialistaMunicipio',
      'isADMunicipio',
      'isAnalistaMunicipio',
      'isAuthenticated',
      'cityId',
      'isSPFesp',
      'isSPFespEspecial',
      'isSPCoordenador'
    ])
  }
}
</script>
